import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  combinedSearchThunk,
  selectTopicQuery,
  selectTopicResults,
} from "../../../features/enhancedSearch";
import classNames from "classnames";
import PropTypes from "prop-types";

const SearchPagination = ({ selectedTab }) => {
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const searchResults = useSelector(selectTopicResults);
  const searchQuery = useSelector(selectTopicQuery);
  const dispatch = useDispatch();
  let activePage = "jp-current";

  useEffect(() => {
    if (searchQuery && searchQuery.top) {
      setItemsPerPage(searchQuery.top);
    }
  }, []);

  const totalPages = Math.ceil(searchResults.totalCount / itemsPerPage);

  const updateItemsPerPage = (event) => {
    setItemsPerPage(parseInt(event.target.value));
    setCurrentPage(1);
    requestResult(1, parseInt(event.target.value));
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber > totalPages) {
      pageNumber = totalPages;
    }
    setCurrentPage(pageNumber);
    requestResult(pageNumber, itemsPerPage);
  };

  const handlePreviousClicked = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };

  const handleNextClicked = () => {
    if (currentPage < totalPages) {
      handlePageChange(currentPage + 1);
    }
  };

  function requestResult(pageNumber, itemsPerPage) {
    dispatch(
      combinedSearchThunk({
        searchText: searchQuery.searchText,
        top: itemsPerPage,
        guidelineFacet: searchQuery.guidelineFacet,
        skip: (pageNumber - 1) * itemsPerPage,
        searchWithin: searchQuery.searchWithin,
      }),
    );
  }

  return (
    <div className="container">
      {selectedTab === 0 && (
        <div>
          <div className="row"></div>

          <div className="col-md-4 col-sm-3 col-xs-12">
            <form className="form-horizontal mTop40px pageCounter" data-gtm-form-interact-id="0">
              <div className="row itemperpage">
                <div className="col-md-5 col-xs-4">
                  <label className="control-label">Items per page:</label>
                </div>
                <div className="col-md-7 col-xs-8 noRightPadding">
                  <select
                    id="items"
                    className="form-control"
                    data-gtm-form-interact-field-id="0"
                    data-testid="itemsPerPage"
                    value={itemsPerPage}
                    onChange={updateItemsPerPage}
                  >
                    <option>10</option>
                    <option>15</option>
                    <option>25</option>
                  </select>
                </div>
              </div>
            </form>
          </div>

          <div className="col-md-8 col-sm-9 col-xs-12 holder">
            <span
              className={classNames("jp-previous", { "jp-disabled": currentPage === 1 })}
              onClick={handlePreviousClicked}
            >
              ← previous
            </span>
            <span
              className={currentPage === 1 ? activePage : ""}
              onClick={() => handlePageChange(1)}
            >
              1
            </span>
            {currentPage - 4 <= 1 ? "" : "..."}
            {Array.from({ length: totalPages }, (_, i) => i + 2).map((pageCount) =>
              (pageCount === currentPage && pageCount !== 1 && pageCount < totalPages) ||
              (pageCount < currentPage + 4 &&
                pageCount > currentPage - 4 &&
                pageCount !== 1 &&
                pageCount < totalPages) ? (
                <span
                  className={currentPage === pageCount ? activePage : ""}
                  key={pageCount}
                  onClick={() => handlePageChange(pageCount)}
                >
                  {pageCount}
                </span>
              ) : (
                ""
              ),
            )}
            {currentPage + 4 < totalPages ? "..." : ""}
            {totalPages > 1 ? (
              <span
                key={totalPages}
                className={currentPage === totalPages ? activePage : ""}
                onClick={() => handlePageChange(totalPages)}
              >
                {totalPages}
              </span>
            ) : (
              ""
            )}
            <span
              key="next-0"
              className={classNames("jp-next", { "jp-disabled": currentPage === totalPages })}
              onClick={handleNextClicked}
            >
              next →
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

SearchPagination.propTypes = {
  selectedTab: PropTypes.number,
};

export default SearchPagination;
